import { FunctionComponent } from "react";
import styles from "./FormField.module.css";
import cn from "classnames";

interface IPreviewFieldProps {
  title?: string;
  text: string;
  className?: string;
}

const PreviewField: FunctionComponent<IPreviewFieldProps> = ({title, text, className}) => {

    return (
      <div
        className={cn(styles.previewField, className)}
      >
        <div className={styles.previewFieldTitle}>{title}</div>
        <div className={styles.previewFieldText}>{text}</div>
      </div>
    );
}

export default PreviewField;
